import { LTime } from '@app/components/date/LTime';
import { BtnLink, Duration, MrtTable } from '@mi-front/ui';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';

import { LDate } from '@app/components/date/LDate';
import { ReportResultProps } from '@app/core/reports/types';
import { Seconds, toTimestamp } from '@mi-front/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { LowerthirdReport, LowerthirdType } from '../../../../types';

export function LowerthirdResult({
  values,
  result,
  isLoading,
}: ReportResultProps<LowerthirdReport>) {
  const { formatMessage } = useIntl();

  const showOnStreamUrlFn = (lowerthird: LowerthirdType) =>
    `/logger/s/${values.station.slug}?cursor=${lowerthird.from}&length=${Math.round(
      (toTimestamp(lowerthird.to) - toTimestamp(lowerthird.from)) / 1000,
    )}&tab=lowerthird`;
  return (
    <MrtTable<LowerthirdType>
      columns={[
        {
          id: 'time',
          header: formatMessage({
            id: 'search.dateTime',
            defaultMessage: 'Fecha y hora',
          }),
          Cell: ({ row: { original } }) => (
            <div style={{ display: 'flex', gap: '0.375rem' }}>
              <LDate value={original.from} day="2-digit" month="2-digit" year="2-digit" />
              <LTime value={original.from} second={'numeric'} />
            </div>
          ),
          enableSorting: true,
          size: 60,
        },
        {
          id: 'text',
          enableSorting: false,
          accessorFn: (row) => row.text,
          header: formatMessage({
            id: 'audit.lowerthird.title',
            defaultMessage: 'Zocalos',
          }),
          size: 200,
        },
        {
          id: 'duration',
          header: formatMessage({
            id: 'audit.lowerthird.duration',
            defaultMessage: 'Duración',
          }),
          Cell: ({ row: { original } }) => (
            <div>
              <Duration
                seconds={
                  ((toTimestamp(original.to) - toTimestamp(original.from)) / 1000) as Seconds
                }
              />
            </div>
          ),
          enableSorting: true,
          size: 30,
        },
        {
          id: 'actions',
          enableSorting: false,
          accessorFn: () => '',
          header: formatMessage({
            id: 'common.text.actions',
            defaultMessage: 'Acciones',
          }),

          size: 30,
          Cell: ({ row }) => (
            <BtnLink
              size="xs"
              to={showOnStreamUrlFn(row.original)}
              openInNewTab
              icon={<OpenInNewIcon />}
              className="mr-2"
            >
              <FormattedMessage
                id="audit.matchesScreen.showOnStreamBtn"
                defaultMessage="Mostrar en stream"
              />
            </BtnLink>
          ),
        },
      ]}
      data={result}
      enableExpandAll={false}
      enableGlobalFilter={false}
      enableFilters={false}
      memoizeColumns={false}
      enableHiding={false}
      enableColumnActions={false}
      state={{
        isLoading,
      }}
    />
  );
}
